export interface ISortBy {
  direction: string;
  field: string;
  queryString: string;
}

//trip list sort by options
export const SortByTitleAsc: ISortBy = {
  direction: 'asc',
  field: 'Title',
  queryString: 'sort=-title'
};

export const SortByTitleDesc: ISortBy = {
  direction: 'desc',
  field: 'Title',
  queryString: 'sort=title'
};

export const SortByLastUpdateRecentFirst: ISortBy = {
  direction: 'asc',
  field: 'UpdatedAt',
  queryString: 'sort=-updatedAt'
};

export const SortByLastUpdateOldFirst: ISortBy = {
  direction: 'desc',
  field: 'UpdatedAt',
  queryString: 'sort=updatedAt'
};

// { value: 'all-itineraries', label: 'All Itineraries' },
// { value: 'only-private', label: 'Only Private' },
// { value: 'only-published', label: 'Only Published' },
// { value: 'a-to-z', label: 'From A to Z' },
// { value: 'newest', label: 'Newest' }
